import * as React from "react";

const LeagueContext = React.createContext();

function leagueReducer(state, action) {
  switch (action.type) {
    case "setLeagueData": {
      let leagueInfo = action.value.leagueInfo;
      let userLeagueData = action.value.userLeagueData;

      return {
        ...state,
        leagueInfo: leagueInfo,
        leagueUserData: userLeagueData,
      };
    }

    case "setLeagueData2": {
      let tournamentTeams = action.value.tournamentTeams;
      let tournamentRounds = action.value.tournamentRounds;
      let includedRounds = state.leagueInfo?.rounds;

      if (!includedRounds) return;
      const leagueRounds = tournamentRounds
        .filter(function (item) {
          if (Object.values(includedRounds).some((el) => el.id === item.id)) {
            return item;
          } else return;
        })
        .map((doc, id) => ({
          pos: id,
          ...doc,
        }));

      let settledRoundCount = leagueRounds.reduce((accumulator, value) => {
        if (value.settled) {
          return accumulator + 1;
        }
        return accumulator;
      }, 0);

      let nextRound = leagueRounds.find((x) => x.pos === settledRoundCount);
      let newSelectedRoundIndex = settledRoundCount;

      if (
        settledRoundCount !== 0 &&
        settledRoundCount === leagueRounds?.length
      ) {
        newSelectedRoundIndex = newSelectedRoundIndex - 1;
      }

      return {
        ...state,
        tournamentInfo: action.value.tournamentInfo,
        leagueTeams: tournamentTeams,
        allRounds: leagueRounds,
        nextRoundId: nextRound?.id,
        selectedRoundIndex: newSelectedRoundIndex,
        isLoading: false,
      };
    }

    case "setLeagueInfo": {
      return {
        ...state,
        leagueInfo: action.value,
        //allRounds: tournamentRounds,
      };
    }

    case "setLeagueTeams": {
      return {
        ...state,
        leagueTeams: action.value,
      };
    }
    case "setIsPlacingPrediction": {
      return {
        ...state,
        leagueIsPlacingPrediction: action.value.leagueIsPlacingPrediction,
      };
    }
    case "setLeagueUserData": {
      return {
        ...state,
        leagueUserData: action.value,
      };
    }
    case "changeTab": {
      return {
        ...state,
        selectedRoundIndex: action.value,
      };
    }
    case "setLoading": {
      return {
        ...state,
        isLoading: action.value,
      };
    }
    //TODO: remove this
    case "setAllRounds": {
      if (!state.leagueInfo?.rounds) return;
      const leagueRounds = action.value
        .filter(function (item) {
          if (state.leagueInfo?.rounds?.some((el) => el === item.id)) {
            return item;
          } else return;
        })
        .map((doc, id) => ({
          pos: id,
          ...doc,
        }));

      let settledRoundCount = leagueRounds.reduce((accumulator, value) => {
        if (value.settled) {
          return accumulator + 1;
        }
        return accumulator;
      }, 0);

      let nextRound = leagueRounds.find((x) => x.pos === settledRoundCount);
      let newSelectedRoundIndex = settledRoundCount;

      if (
        settledRoundCount !== 0 &&
        settledRoundCount === leagueRounds?.length
      ) {
        newSelectedRoundIndex = newSelectedRoundIndex - 1;
      }

      return {
        ...state,
        allRounds: leagueRounds,
        nextRoundId: nextRound?.id,
        selectedRoundIndex: newSelectedRoundIndex,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function LeagueProvider({ children }) {
  const [state, dispatch] = React.useReducer(leagueReducer, {
    selectedRoundIndex: undefined,
    allRounds: [],
    nextRoundId: undefined,
    leagueInfo: undefined,
    leagueUserData: undefined,
    leagueTeams: [],
    leagueIsPlacingPrediction: false,
    isLoading: true,
    tournamentInfo: undefined,
  });

  const value = { state, dispatch };
  return (
    <LeagueContext.Provider value={value}>{children}</LeagueContext.Provider>
  );
}

function useLeague() {
  const context = React.useContext(LeagueContext);
  if (context === undefined) {
    throw new Error("useLeague must be used within a LeagueProvider");
  }
  return context;
}

export { LeagueProvider, useLeague };
